export const ADMIN_ANALYTICS_TABS = ["growth", "delivery", "offer-clicks"] as const;
export type AdminAnalyticsTab = (typeof ADMIN_ANALYTICS_TABS)[number];
